// Vérifie si un mot de passe a été compromis via l'API publique HaveIBeenPwned (HIBP).
// Principe de k-anonymity : le mot de passe est haché en SHA-1 localement, puis seuls
// les 5 premiers caractères du hash sont envoyés au serveur HIBP. Le mot de passe en
// clair ne quitte jamais le navigateur, et le hash complet n'est jamais transmis.
export async function isPasswordPwned(password: string): Promise<boolean> {
  try {
    const data = new TextEncoder().encode(password);
    const hashBuffer = await crypto.subtle.digest('SHA-1', data);
    const hashHex = Array.from(new Uint8Array(hashBuffer))
      .map((b) => b.toString(16).padStart(2, '0'))
      .join('')
      .toUpperCase();
    const prefix = hashHex.slice(0, 5);
    const suffix = hashHex.slice(5);

    const res = await fetch(`https://api.pwnedpasswords.com/range/${prefix}`, {
      headers: { 'Add-Padding': 'true' },
    });
    if (!res.ok) return false;

    const body = await res.text();
    return body.split('\n').some((line) => {
      const hashSuffix = line.split(':')[0];
      return hashSuffix.trim() === suffix;
    });
  } catch {
    // Fail-open : si l'API est indisponible, on ne bloque pas l'utilisateur
    return false;
  }
}